import React from "react";
import LazyLoad from "react-lazyload";
import { Link } from "react-router-dom";
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
      <div className="footer padded-sec">
        <div className="container-fluid">
          <div class="waves">
            <div class="wave" id="wave1"></div>
            <div class="wave" id="wave2"></div>
            <div class="wave" id="wave3"></div>
            <div class="wave" id="wave4"></div>
          </div>

          {/* <div className="row border-line">
            <div className="col-lg-6">
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/logo.png"
                  alt="Frank Anthony Bangalore"
                  className="img-fluid mx-auto d-block" />
              </LazyLoad>
            </div>
            <div className="col-lg-6">
              <div className="social_media">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/twitter.png"
                  className="social-media img-fluid"
                />
              </div>
            </div>
          </div> */}
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-2">
              <h3>Our Links</h3>
              <ul>
                <li>
                  <i class="bi bi-caret-right-fill"></i>{" "}
                  <Link to="/"> Home </Link>
                </li>
                <li>
                  <i class="bi bi-caret-right-fill"></i>
                  <Link to="/about-us"> About Us </Link>
                </li>
                <li>
                  <i class="bi bi-caret-right-fill"></i>
                  <Link to="/"> Fee Structure </Link>
                </li>
                <li>
                  <i class="bi bi-caret-right-fill"></i>
                  <Link to="/gallery"> Photo Gallery</Link>
                </li>
                <li>
                  <i class="bi bi-caret-right-fill"></i>
                  <Link to="/contact-us"> Contact Us </Link>
                </li>
              </ul>
            </div>
            <div className="col-sm-6 col-md-6 col-lg-6 col-xl-3">
              <h3>Contact Us</h3>
              <p>
                <Link
                  to="https://maps.app.goo.gl/HHd9fgyQkrTSEriq9"
                  target="_blank"
                >
                  <i class="bi bi-geo-alt-fill"></i> The Frank Anthony Junior
                  School, 26, Wellington Street, Richmond Town,
                  Bangalore - 560025
                </Link>
              </p>
              <p>
                <Link to="mailto:fajschool@gmail.com">
                  <i class="bi bi-envelope-fill"></i>fajschool@gmail.com
                </Link>{" "}
              </p>
              <p>
                <Link to="tel:080 22212386">
                  <i class="bi bi-telephone-fill"></i> 080 22212386{" "}
                </Link>
              </p>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d7776.251189949486!2d77.5989719!3d12.9638142!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTLCsDU3JzQ3LjAiTiA3N8KwMzYnMTUuNCJF!5e0!3m2!1sen!2sin!4v1764648325892!5m2!1sen!2sin"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-4 footer-sec">
              <div class="mobile-app">
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/Mobile-slides.png"
                  class="img-fluid mobile"
                  alt="Frank Anthony Bangalore"
                />
                <div class="app-sec">
                  <h3>Download Mobile App</h3><br />
                  {/* <h3>School ERP:CampusCare (Entab)</h3> */}
                  <p>
                    Click the icons below to download the Mobile App, and use<br />
                    <i>Use School Code:</i> FAJSBL
                  </p><br />
                  <ul>
                    <li>
                      <a
                        href="https://apps.apple.com/in/app/campuscare-10x/id1611283814"
                        target="_blank"
                      >
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/home-app-store.png"
                          class="img-fluid app-icon"
                          alt="Frank Anthony Bangalore"
                        />
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://play.google.com/store/apps/details?id=com.entab.learninglab&hl=en-IN"
                        target="_blank"
                      >
                        <img
                          src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/FAJUNIORSB/public/Images/home-app-google-play.png"
                          class="img-fluid app-icon"
                          alt="Frank Anthony Bangalore"
                        />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              {/* <h6>
                <a>Download Mobile App</a>
              </h6> */}
            </div>
          </div>
        </div>
      </div>
      <div className="copyright">
        Copyright ©️ Frank Anthony Junior School, {currentYear} . All Right
        Reserved. Accelerating By{" "}
        <a href="https://entab.in/" target="_blank">
          Entab Infotech : CampusCare®️
        </a>
      </div>
    </>
  );
};

export default Footer;
